import type { Localized } from './home.content';

export const CONSENT_BANNER: {
  title: Localized;
  body: Localized;
  accept: Localized;
  reject: Localized;
  privacy: Localized;
  settings: Localized;
} = {
  title: {
    en: 'Help us improve AskFlow',
    ar: 'ساعدنا في تطوير AskFlow',
  },
  body: {
    en: 'Optional cookies show us which pages and ads help venues find us, so we can keep improving. They stay off unless you accept.',
    ar: 'تساعدنا ملفات تعريف الارتباط الاختيارية على معرفة الصفحات والإعلانات التي تُوصل المنشآت إلينا، لنواصل التطوير. تبقى متوقفة ما لم توافق عليها.',
  },
  accept: { en: 'Accept', ar: 'موافقة' },
  reject: { en: 'Decline', ar: 'رفض' },
  privacy: { en: 'Privacy policy', ar: 'سياسة الخصوصية' },
  settings: { en: 'Cookie settings', ar: 'إعدادات ملفات تعريف الارتباط' },
};
